export default {
  methods: {
    str_format_month(value) {
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        return `${parseInt(value, 10)} mois`
      }
    },
    /* @deprecated */
    /* @todo should $t() with plural */
    str_format_year(value) {
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        const n = parseInt(value, 10)

        return `${n} an${n > 1 ? 's' : ''}`
      }
    },
    str_format_percentage(value, precision) {
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        if (typeof precision !== 'undefined' && parseInt(precision, 10) > 0) {
          return `${parseFloat(value, 10)
            .toFixed(parseInt(precision, 10))
            .toString()
            .replace('.', ',')} %`
        } else {
          return `${parseInt(value, 10)} %`
        }
      }
    },
  },
}
